module.exports = __webpack_public_path__ + "img/family-13.ef5d57f2.png";